export const LOGIN_INITIATE = 'LOGIN_INITIATE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_TIMEOUT = 'LOGIN_TIMEOUT'
export const SET_IDENTITY = 'SET_IDENTITY'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGIN_CHECK = 'LOGIN_CHECK'
export const SET_ROLE = 'SET_ROLE'
